import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@environments/environment';

import { routes } from '@model/constants/routes';

import { CheckProcessResponseType } from './models';

@Injectable({
  providedIn: 'root',
})
export class CheckProcessService {
  private apiUrl: string;
  private http: HttpClient;

  constructor(private readonly injector: Injector) {
    this.http = this.injector.get(HttpClient);
    this.apiUrl = environment.apiUrl;
  }

  public checkProcess(): Observable<CheckProcessResponseType> {
    return this.http
      .post<{ response: CheckProcessResponseType }>(`${this.apiUrl}${routes.checkProcess}`, {})
      .pipe(map(({ response }) => response));
  }
}
